import styles from '../../assets/jss/Login/loginPage';
import freeSens from "../../assets/img/FreeSensSmartView-logo-White.svg";
import makeStyles from '@mui/styles/makeStyles';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';

const useStyles = makeStyles(styles);

const LoginBanner = ({ crm, isScanCenter }) => {
    const classes = useStyles();

    const [innerHeight, setInnerHeight] = useState(window.innerHeight);

    const handleResize = () => {
        setInnerHeight(window.innerHeight);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            {innerHeight &&
                <Grid className={classes.loginHeader}>
                    <Grid style={{ position: 'absolute', top: '89px' }} item xs={12}>
                        <img style={{ width: '192px' }} src={freeSens} alt='' />
                    </Grid>
                    {!crm &&
                        <Grid style={{ position: 'absolute', top: '185px' }} item xs={12}>
                            <p className={classes.agent}>{isScanCenter ? 'مرکز اسکن' : "دستیار"}</p>
                        </Grid>}
                    {crm &&
                        <div style={{
                            top: '210px',
                            position: 'absolute',
                            margin: '0 auto 0',
                            fontFamily: 'Kalameh',
                            fontSize: '18px',
                            color: '#d8d8d8',
                            height: '25px',
                            letterSpacing: '1.8px',
                            textAlign: 'center',
                        }}>
                            CRM
                        </div>}
                </Grid>
            }
        </>
    );
};

export default LoginBanner;
